import { BazaarVoiceRating } from 'components/helpers/BazaarVoice/BazaarVoiceRating';
import { OneTrustFilter } from 'components/helpers/OneTrust';
import { useDisabledFeatureFlags } from 'lib/hooks/useDisabledFeatureFlags';
import styles from './BazaarVoiceReviewsQuestions.module.scss';
import { useContentItem } from 'lib/hooks/useContentItem';

export function BazaarVoiceReviewsQuestions() {
  const disabledFeatures = useDisabledFeatureFlags();
  const contentItem = useContentItem() as { RatingAndReviewContentId?: string } | null;
  if (disabledFeatures?.BV || !contentItem?.RatingAndReviewContentId) {
    return null;
  }
  return (
    <div className={`${styles.bvWrapper} printHide`}>
      <OneTrustFilter
        optanonGroups={['2', '3', '4']}
        enablePlaceholder={true}
        placeholderFeatureType="ratings"
        filteredComponent={
          <>
            <BazaarVoiceRating
              ratingAndReviewContentId={contentItem.RatingAndReviewContentId}
              showType="reviews"
            />
            <BazaarVoiceRating
              ratingAndReviewContentId={contentItem.RatingAndReviewContentId}
              showType="questions"
            />
          </>
        }
      />
    </div>
  );
}
